var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logoutCon"},[_c('p',[_vm._v("是否要退出登录吗？")]),_c('div',[_c('div',{on:{"click":_vm.logoutBtn}},[_vm._v("确认")]),_c('div',{on:{"click":_vm.goAudienceInfo}},[_vm._v("取消")])])])}
var staticRenderFns = []

export { render, staticRenderFns }